import React from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import BottomNavigation from "./BottomNavigation";
import { useLibraryPrefetch } from "@/hooks/useLibraryData";
import { useHomePrefetch } from "@/hooks/useHomePrefetch";
import { useChatPrefetch } from "@/hooks/useChatPrefetch";
import { useKeyboardVisible } from "@/hooks/useKeyboardVisible";
import { NotificationPermissionPrompt } from "./NotificationPermissionPrompt";
import SubscriptionBanner from "./SubscriptionBanner";
import BannerHost from "@/components/banners/BannerHost";
import { useAuth } from "@/contexts/AuthContext";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const keyboardVisible = useKeyboardVisible();

  // טעינה מדורגת: hooks מוגנים פנימית — ידלגו אם אין user
  const { isDone: homePrefetchDone } = useHomePrefetch();
  useLibraryPrefetch({ enabled: isAuthenticated && homePrefetchDone });
  useChatPrefetch({ enabled: isAuthenticated && homePrefetchDone });

  return (
    <div className="h-[100dvh] flex flex-col bg-gradient-to-b from-muted-warm to-white overflow-hidden" dir="rtl">
      <Header currentPath={location.pathname} />
      {isAuthenticated && <SubscriptionBanner />}
      {isAuthenticated && <BannerHost />}
      {isAuthenticated && <NotificationPermissionPrompt />}
      <main
        className={`flex-1 overflow-y-auto overscroll-none md:pb-6 ${
          keyboardVisible
            ? "pb-0"
            : "pb-[max(60px,calc(48px+env(safe-area-inset-bottom)))]"
        }`}
      >
        <div className="w-full mx-auto px-4 py-6 gap-6">
          {children}
        </div>
      </main>
      {!keyboardVisible && <BottomNavigation currentPath={location.pathname} />}
    </div>
  );
};

export default Layout;
